import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import {
  OpenedTooltip,
} from 'web-types';

import SidebarItem from './SidebarItem';

import * as S from './styled';

interface SidebarItemType {
  name: string
  link: string
  icon: string
  requiresPremium?: boolean
}

type Props = {
  items: SidebarItemType[];
  openedTooltips: OpenedTooltip[];
  onClickItem: { (e: any, item: SidebarItemType): void };
  namespace: any;
}

const Sidebar = ({
  items,
  namespace,
  openedTooltips,
  onClickItem,
}: Props) => (
  <S.Sidebar>
    <S.Logo
      to="/welcome"
      logo={namespace.logo?.url}
    />
    <Flex
      column
      scrollY
      width="100%"
      padding="0 0 20px 0"
      data-tour="tour__nav"
    >
      {items.map(item => (openedTooltips.some(el => el.key === item.name) ? (
        <Tooltip
          key={item.link}
          fill="light"
          body={`Click ${item.name}.`}
          toggleMode
          initialState
        >
          <SidebarItem
            {...item}
            onClick={(e) => {
              onClickItem(e, item)
            }}
          />
        </Tooltip>
      ) : (
        <SidebarItem
          key={item.link}
          onClick={(e) => {
            onClickItem(e, item)
          }}
          {...item}
        />
      )))}
    </Flex>
  </S.Sidebar>
);

export default Sidebar;
